module.exports = __webpack_public_path__ + "static/media/mico-leao-dourado.6e64028a.mp3";